import { Randstad } from './Randstad';

export class RemoteRepresentativeRandstad extends Randstad {
    constructor() {
        super();
        this.setRandstadTypography();
    }

    private setRandstadTypography() {
        this.typography.button.text.textTransform = 'lowercase';
    }
}

const remoteRepresentativeRandstadTheme = new RemoteRepresentativeRandstad();
export default remoteRepresentativeRandstadTheme;



// WEBPACK FOOTER //
// webpack://frontendThemeProvider/src/themes/Randstad/remote-representative.ts